import * as actions from "./actions"
const toggleShowPromotionModal = actions.toggleShowPromotionModal;
const updatedAppliedPromotion = actions.updatedAppliedPromotion;
const updatePromotionAppliedCart = actions.updatePromotionAppliedCart;
const updateAppliedOrderPromotions = actions.updateAppliedOrderPromotions;
const updateFreeItemsCart = actions.updateFreeItemsCart;
const validatePromoCode = actions.validatePromoCode;
const reValidatePromoCode = actions.reValidatePromoCode;
const removePromoReservation = actions.removePromoReservation;
const updateAppliedPromoCodeDetails = actions.updateAppliedPromoCodeDetails;

export default {
  toggleShowPromotionModal,
  updatedAppliedPromotion,
  updatePromotionAppliedCart,
  updateAppliedOrderPromotions,
  updateFreeItemsCart,
  validatePromoCode,
  reValidatePromoCode,
  removePromoReservation,
  updateAppliedPromoCodeDetails,
}
